import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { motion } from "framer-motion";
import { SEOHead } from "@/components/SEOHead";

const Reembolso = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Política de Reembolso y Garantía de 30 Días | CreceLocal"
        description="Nuestra garantía de 30 días: si no ves una mejora real en tu proceso comercial, te devolvemos tu dinero. Conocé los detalles de nuestra política de reembolso."
        canonical="/reembolso"
      />
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-[800px]">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="prose prose-invert prose-sm sm:prose-base md:prose-lg max-w-none"
          >
            <h1 className="text-4xl md:text-5xl font-medium tracking-tight mb-8 text-foreground">
              Política de Reembolso
            </h1>

            <p className="text-muted-foreground mb-12">
              <strong>CreceLocal LLC</strong>
              <br />
              Última actualización: junio 2025
            </p>

            <div className="space-y-12 text-muted-foreground">
              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  1. Garantía de 30 días
                </h2>
                <p>
                  CreceLocal ofrece una garantía de satisfacción de 30 días a
                  partir del inicio del servicio. Si durante ese período no ves
                  una mejora real en tu proceso comercial, podés solicitar el
                  reembolso completo del monto abonado.
                </p>
                <p className="mt-4 mb-4">Para activar la garantía debés:</p>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    Haber usado el sistema durante el período (la garantía no
                    aplica si el sistema no fue configurado o utilizado)
                  </li>
                  <li>
                    Contactarnos antes de que venzan los 30 días a
                    info@crecelocal.com con el asunto "Solicitud de reembolso"
                  </li>
                  <li>
                    Describir brevemente por qué el sistema no generó el
                    resultado esperado
                  </li>
                </ol>
                <p className="mt-4">
                  Procesamos la solicitud en un plazo de 5 días hábiles y el
                  reembolso se acredita en el método de pago original dentro de
                  los 10 días hábiles siguientes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  2. Planes de suscripción mensual
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    Las suscripciones mensuales son cancelables en cualquier
                    momento
                  </li>
                  <li>
                    No se realizan reembolsos proporcionales por días no
                    utilizados dentro de un ciclo de facturación ya cobrado
                  </li>
                  <li>
                    La cancelación es efectiva al final del ciclo en curso — el
                    acceso se mantiene hasta esa fecha
                  </li>
                  <li>
                    La garantía de 30 días aplica al primer mes de cada plan
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  3. Implementación personalizada
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    El pago único de implementación no es reembolsable una vez
                    iniciado el trabajo de configuración
                  </li>
                  <li>
                    Si la implementación no fue iniciada, podés solicitar el
                    reembolso completo dentro de las 48 horas posteriores al
                    pago
                  </li>
                  <li>
                    La garantía de 30 días aplica al plan mensual incluido en la
                    implementación, no al costo de la implementación en sí
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  4. Créditos de uso de IA (tokens)
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    Los créditos de tokens consumidos no son reembolsables
                  </li>
                  <li>
                    Los créditos no consumidos al momento de la cancelación no
                    se reembolsan ni se transfieren
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  5. Excepciones
                </h2>
                <p className="mb-4">
                  No aplica la garantía ni ningún reembolso en los siguientes
                  casos:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    Incumplimiento de los Términos y Condiciones que haya
                    resultado en la suspensión de la cuenta
                  </li>
                  <li>Fraude o uso indebido de la plataforma</li>
                  <li>
                    Solicitudes realizadas luego de vencido el plazo de 30 días
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  6. Disputas de pago
                </h2>
                <p>
                  Si iniciás una disputa o contracargo con tu banco o procesador
                  de pago sin contactarnos previamente, CreceLocal se reserva el
                  derecho de suspender el acceso a la cuenta mientras dure la
                  disputa.
                </p>
                <p className="mt-4">
                  Te recomendamos siempre contactarnos primero — resolvemos la
                  gran mayoría de los casos de forma directa y rápida.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  7. Contacto
                </h2>
                <p>
                  Para solicitudes de reembolso o consultas sobre esta política:
                </p>
                <div className="mt-4">
                  <p>CreceLocal LLC</p>
                  <p>131 Continental Dr, Suite 305</p>
                  <p>Newark, DE 19713</p>
                  <p>Estados Unidos</p>
                  <p>info@crecelocal.com</p>
                  <p>crecelocal.com</p>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Reembolso;
